import { ButtonElement } from '../shared/buttonElement/ButtonElement';
import { LoaderElement } from '../shared/loaderElement/LoaderElement';
import { SectionElement } from '../shared/sectionElement/SectionElement';
import type { LoggedInTeaserElementProps } from './LoggedInTeaserElement.types';

export function LoggedInTeaserElement(props: LoggedInTeaserElementProps) {
  const {
    translations,
    onClickButton,
    buttonLabel,
    title,
    children,
    isButtonDisabled = false,
    buttonType = 'button',
  } = props;

  return (
    <div className="relative">
      <div className="flex flex-col gap-6 blur-sm">
        {translations?.['billing.current_plan.title'] && translations?.['billing.summary.empty_state'] ? (
          <SectionElement
            title={translations?.['billing.current_plan.title']}
            subTitle={translations?.['billing.summary.empty_state']}
          >
            <LoaderElement count={4} />
          </SectionElement>
        ) : null}
        {translations?.['billing.summary.title'] ? (
          <SectionElement
            title={translations?.['billing.summary.title']}
            subTitle={translations?.['billing.summary.title']}
          >
            <LoaderElement count={4} />
          </SectionElement>
        ) : null}
        {translations?.['manage.preferences.title'] ? (
          <SectionElement
            title={translations?.['manage.preferences.title']}
            subTitle={translations?.['manage.preferences.description']}
          >
            <LoaderElement count={4} />
          </SectionElement>
        ) : null}
        {translations?.['manage.orders.title'] ? (
          <SectionElement
            title={translations?.['manage.orders.title']}
            subTitle={translations?.['manage.orders.description']}
          >
            <LoaderElement count={4} />
          </SectionElement>
        ) : null}
      </div>
      <div className="absolute top-12 left-1/2 -translate-x-1/2 flex flex-col gap-2 justify-center items-center z-10">
        {<p className="w-full text-center text-sm font-bold text-gray-600 leading-5">{title}</p>}
        <ButtonElement variant="primary" type={buttonType} disabled={isButtonDisabled} onClick={onClickButton}>
          {buttonLabel}
        </ButtonElement>
      </div>
      {children}
    </div>
  );
}
